import axios from 'axios';
import { env } from '../env';

export const fireblocksClient = axios.create({
  baseURL: env.NEXT_PUBLIC_DJANGO_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to attach API key from sessionStorage
fireblocksClient.interceptors.request.use(
  (config) => {
    if (typeof window !== 'undefined') {
      const apiKey = sessionStorage.getItem('django_api_key');
      const userEmail = sessionStorage.getItem('user_email');

      if (userEmail && apiKey) {
        // Django TastyPie expects: "ApiKey email:key"
        config.headers.Authorization = `ApiKey ${userEmail}:${apiKey}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle 401/403 errors
fireblocksClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Invalid API key - clear session and redirect to signin
      if (typeof window !== 'undefined') {
        sessionStorage.removeItem('django_api_key');
        sessionStorage.removeItem('user_email');
        window.location.href = '/signin';
      }
    }

    return Promise.reject(error);
  }
);
